import { render, staticRenderFns } from "./ConfirmNetBookDisposal.vue?vue&type=template&id=ba5957e8"
import script from "./ConfirmNetBookDisposal.vue?vue&type=script&lang=js"
export * from "./ConfirmNetBookDisposal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports